export default function HeroSection() {
  return (
    <section className="relative h-[500px] md:h-[650px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20artistic%20product%20photography%20collage%20featuring%20various%20fashion%20items%20including%20sneakers%20hoodies%20t-shirts%20bags%20and%20accessories%20arranged%20creatively%20on%20a%20light%20mint%20cream%20gradient%20background%20editorial%20style%20with%20soft%20diffused%20natural%20lighting%20clean%20minimalist%20aesthetic%20pastel%20mint%20and%20warm%20beige%20tones%20gentle%20shadows%20harmonious%20composition%20no%20text%20no%20logos%20airy%20elegant%20atmosphere&width=1600&height=900&seq=yoybuy-hero-bg-01&orientation=landscape"
        alt="YOYbuy Sheet - коллекция товаров из Китая"
        title="YOYbuy Sheet — умный шоппинг из Китая"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 h-full w-full flex items-center px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="text-sm md:text-base font-label tracking-widest text-primary-300 mb-4 uppercase">
            YOYbuy Sheet
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight">
            Умный шоппинг
            <br />
            <span className="text-primary-300">из Китая</span>
          </h1>
          <p className="mt-5 text-sm md:text-base text-white/80 max-w-lg leading-relaxed">
            Организуйте заказы из Китая с помощью удобных таблиц YOYbuy Sheet. Каталог из 14 категорий товаров: обувь, одежда, аксессуары и многое другое.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Смотреть таблицу
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-full border border-white/40 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Категории товаров
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 pb-6 md:pb-10 px-6 md:px-10">
        <p className="text-6xl md:text-8xl lg:text-9xl font-heading font-extrabold text-white/15 select-none whitespace-nowrap">
          Покупай умнее
        </p>
      </div>
    </section>
  );
}